var path = 'event/event-header-stats.tpl.html';
var html = " <div translate class=tb-cell flex>event.event-time</div> <div translate class=tb-cell flex>event.server</div> <div translate class=\"tb-cell tb-number\" flex>event.messages-processed</div> <div translate class=\"tb-cell tb-number\" flex>event.errors-occurred</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/event/event-header-stats.tpl.html
// module id = 1481
// module chunks = 1